<template lang="pug">
div
  .container-cards
    .cards
      app-card-dashboard.card-dashboard(
        title="Processos atrasados"
        :content="infoPrazos.totalVencidos"
        icon="fal fa-engine-warning"
        color="#FF5D67"
      )
      app-card-dashboard.card-dashboard.cardDashboardStyle(
        title="Processos prestes a atrasar"
        :content="infoPrazos.totalAVencer"
        icon="fal fa-alarm-exclamation"
        color="#FFD36B"
      )
      app-card-dashboard.card-dashboard.cardDashboardStyle(
        title="Processos em dia"
        :content="infoPrazos.totalEmDia"
        icon="fal fa-check-circle"
        color="#11B88B"
      )
</template>

<script>
import AppCardDashboard from '@/components/AppCardDashboard'

export default {
  components: {
    AppCardDashboard
  },

  props: {
    infoPrazos: {
      type: Object,
      required: true
    }
  },

  data () {
    return {}
  },

  created () {
  },

  methods: {

  }
}
</script>

<style lang="scss" scoped>
.el-tab-pane {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 450px;
}

.container-tab-grafico-usuario {
  margin-top: 50px;
}

.container-cards {
  padding: 20px;
}

.cards {
  display: flex;
}

.card-dashboard {
  margin-right: 20px;
  max-width: 350px;
}

.card-dashboard:first-child {
  margin-left: 0;
}

@media (max-width: 780px) {
  .cards {
    flex-direction: column;
  }

  .cardDashboardStyle {
    margin: 5px 15px 20px 0px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/AppRelatorioPrazos.vue